//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/BasicEffectivityBuilder.js";
let d=[[[0,"EffectivityFormula",0,0],[0,"EffectivityType",1,0]],[[["fromUnit","toUnit"],"AddUnitEffectivity",{},2,0],[["fromUnit","toUnitType"],"AddUnitEffectivity1",{},2,0],[["fromUnit","toUnit"],"RemoveUnitEffectivity",{},2,0],[["fromUnit","toUnitType"],"RemoveUnitEffectivity1",{},2,0],[["beBuilder"],"RegisterBasicEffectivityBuilder",{},1,1]],[]];
SPLM.EffectivityConditionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.EffectivityConditionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.EffectivityConditionBuilder.EffectivityConditionType = Object.freeze({
    "Unit" : "Unit", "UnitRange" : "UnitRange"});

SPLM.EffectivityConditionBuilder.ToUnitType = Object.freeze({
    "StockOut" : "StockOut", "OpenEnd" : "OpenEnd"});

export default SPLM;